import { RupeesToPaise } from "./commaSeperator";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const date = new Date();
let currentMonth = date.getMonth();

export const getPastSixMonths = (month = currentMonth, arr = []) => {
  if (currentMonth === 5)
    return ["January", "February", "March", "April", "May", "June"];
  let i = month;
  if (arr.length === 6) {
    return arr.reverse();
  } else if (i === 0) {
    arr.push(months[i]);
    i = 11;
    arr.push(months[i]);
    getPastSixMonths(i, arr);
  } else {
    arr.push(months[i]);
    getPastSixMonths(i - 1, arr);
  }
  return arr;
};

export const getPastSixMonthsWithData = (graphData, type) => {
  let arr1 = [0, 0, 0, 0, 0, 0];
  let pastSixMonths = getPastSixMonths();

  pastSixMonths.map((monthData, index) => {
    graphData?.map((gData, i) => {
      if (gData["month"] === monthData) {
        arr1[index] = RupeesToPaise(gData[type]);
      } else {
        if (arr1[index]) {
          arr1[index] = arr1[index];
        } else {
          arr1[index] = 0;
        }
      }
    });
  });

  return arr1;
};
